export default "__VITE_ASSET__DFijMRTA__"